// src/components/DashboardLayout.jsx
import React, { useState } from 'react';
import { NavLink, Outlet,  useNavigate } from 'react-router-dom';
import { Menu, X, LayoutDashboard, Package, Truck, MapPin, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

export default function DashboardLayout() {
  const { user, loading } = useAuth();
  // const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  if (loading) return <div>Loading...</div>;
  if (!user) {
    return <div>Please log in to access this area.</div>;
  }

  const handleLogout = async () => {
    try {
      setLoggingOut(true);
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      setLoggingOut(false);
    }
  };

  const menuItems = [
        {path: '/dashboard/prototype', label: 'Admin Prototype', icon: Package },

    { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/dashboard/orders', label: 'Orders', icon: Package },
    { path: '/dashboard/parcel', label: 'Parcel Management', icon: Truck },
    { path: '/dashboard/tracking', label: 'Tracking', icon: MapPin },
    { path: '/dashboard/delivery-queue', label: 'Delivery Queue', icon: Package },
    { path: '/dashboard/warehouse-queue', label: 'Warehouse Queue', icon: Package },

  ]

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      
      {/* Sidebar */}
      <aside
        style={{
          width: isOpen ? '280px' : '0',
          background: 'linear-gradient(180deg, #4527a0, #5e35b1)',
          color: 'white',
          transition: 'width 0.3s',
          overflow: 'hidden',
          position: 'fixed',
          height: '100%',
          zIndex: 1000
        }}
      >
        <div style={{ padding: '1.5rem', display: 'flex', justifyContent: 'space-between' }}>
          <h2>Dashboard</h2>
          <button
            onClick={() => setIsOpen(false)}
            style={{ background: 'none', border: 'none', color: 'white' }}
          >
            <X size={24} />
          </button>
        </div>

        {/* User Info */}
        <div style={{ padding: '0 1.5rem 1rem', fontSize: '0.9rem', opacity: 0.9 }}>
          <div>{user.displayName || "User"}</div>
          <div style={{ fontSize: '0.8rem', opacity: 0.7 }}>{user.email}</div>
        </div>

        <nav style={{ padding: '1rem 0' }}>
          {menuItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '1rem 1.5rem',
                color: 'white',
                textDecoration: 'none',
                background: isActive ? 'rgba(255,179,0,0.2)' : 'transparent',
                borderLeft: isActive ? '4px solid #ffb300' : 'none'
              })}
              onClick={() => setIsOpen(false)}
            >
              <item.icon size={20} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Logout Button */}
        <div style={{ marginTop: 'auto', padding: '1.5rem' }}>
          <button
            onClick={handleLogout}
            disabled={loggingOut}
            style={{
              width: '100%',
              padding: '0.8rem',
              background: '#ff5252',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              cursor: loggingOut ? 'not-allowed' : 'pointer',
              opacity: loggingOut ? 0.7 : 1
            }}
          >
            <LogOut size={18} />
            {loggingOut ? "Signing Out..." : "Sign Out"}
          </button>
        </div>

      </aside>

      {/* Main content */}
      <div
        style={{
          flex: 1,
          marginLeft: isOpen ? '280px' : '0',
          transition: 'margin-left 0.3s'
        }}
      >
        {/* Mobile header */}
        <header
          style={{
            padding: '1rem',
            background: '#4527a0',
            color: 'white',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <button
            onClick={() => setIsOpen(true)}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              marginRight: '1rem'
            }}
          >
            <Menu size={28} />
          </button>
          <h1>Order Management</h1>
        </header>

        <main style={{ padding: '2rem' }}>
          <Outlet />
        </main>
      </div>

      {isOpen && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 999
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}
// // src/components/DashboardLayout.jsx
// import React, { useState } from 'react';
// import { NavLink, Outlet, useLocation } from 'react-router-dom';
// import { Menu, X, LayoutDashboard, Package, Truck, MapPin } from 'lucide-react';
// import { useAuth } from '../context/AuthContext';

// export default function DashboardLayout() {
//   const { user, loading } = useAuth();
//   const location = useLocation();
//   const [isOpen, setIsOpen] = useState(false);

//   if (loading) return <div>Loading...</div>;
//   if (!user) {
//     // Redirect or show message — but better to handle this in route protection
//     return <div>Please log in to access this area.</div>;
//   }

//   const menuItems = [
//     { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
//     { path: '/dashboard/orders', label: 'Orders', icon: Package },
//     { path: '/dashboard/parcel', label: 'Parcel Management', icon: Truck },
//     { path: '/dashboard/tracking', label: 'Tracking', icon: MapPin },
//   ];

//   return (
//     <div style={{ display: 'flex', minHeight: '100vh' }}>
//       {/* Sidebar */}
//       <aside
//         style={{
//           width: isOpen ? '280px' : '0',
//           background: 'linear-gradient(180deg, #4527a0, #5e35b1)',
//           color: 'white',
//           transition: 'width 0.3s',
//           overflow: 'hidden',
//           position: 'fixed',
//           height: '100%',
//           zIndex: 1000
//         }}
//       >
//         <div style={{ padding: '1.5rem', display: 'flex', justifyContent: 'space-between' }}>
//           <h2>Dashboard</h2>
//           <button onClick={() => setIsOpen(false)} style={{ background: 'none', border: 'none', color: 'white' }}>
//             <X size={24} />
//           </button>
//         </div>

//         <nav style={{ padding: '1rem 0' }}>
//           {menuItems.map(item => (
//             <NavLink
//               key={item.path}
//               to={item.path}
//               style={({ isActive }) => ({
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '12px',
//                 padding: '1rem 1.5rem',
//                 color: 'white',
//                 textDecoration: 'none',
//                 background: isActive ? 'rgba(255,179,0,0.2)' : 'transparent',
//                 borderLeft: isActive ? '4px solid #ffb300' : 'none'
//               })}
//               onClick={() => setIsOpen(false)}
//             >
//               <item.icon size={20} />
//               <span>{item.label}</span>
//             </NavLink>
//           ))}
//         </nav>
//       </aside>

//       {/* Main content */}
//       <div style={{ flex: 1, marginLeft: isOpen ? '280px' : '0', transition: 'margin-left 0.3s' }}>
//         {/* Mobile header */}
//         <header style={{ padding: '1rem', background: '#4527a0', color: 'white', display: 'flex', alignItems: 'center' }}>
//           <button onClick={() => setIsOpen(true)} style={{ background: 'none', border: 'none', color: 'white', marginRight: '1rem' }}>
//             <Menu size={28} />
//           </button>
//           <h1>Order Management</h1>
//         </header>

//         <main style={{ padding: '2rem' }}>
//           <Outlet /> {/* Renders child routes */}
//         </main>
//       </div>

//       {isOpen && (
//         <div
//           style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 999 }}
//           onClick={() => setIsOpen(false)}
//         />
//       )}
//     </div>
//   );
// }